import React from 'react';
import { UncontrolledCarousel } from 'reactstrap';

const items = [
  {
    src:'/imgs/researchtypes/appartment.png',
    altText: 'Slide 1',
    caption: 'Slide 1',
    header: 'Slide 1 Header',
    key: '1'
  },
  {
    src:'/imgs/researchtypes/appartment.png',
    altText: 'Slide 2',
    caption: 'Slide 2',
    header: 'Slide 2 Header',
    key: '2'
  },
  {
    src:'/imgs/researchtypes/appartment.png',
    altText: 'Slide 3',
    caption: 'Slide 3',
    header: 'Slide 3 Header',
    key: '3'
  }
];

const CarouselMobile = () => <UncontrolledCarousel className="mob" items={items} />;

export default CarouselMobile;
